import { useCallback } from 'react';

import { hooks } from '@febos-io/common';
import { payCompanyOrder } from '../../config/apiConfig/companyOrder';

export function usePayCompanyOrderCallback(companyId, orderId, onError) {
  const { callback: onPay, loading } = hooks.useRequestCallback(
    useCallback(
      async (request, { comprobanteType, paymentMethod }) => {
      // eslint-disable-next-line no-return-await
        return await request.exec(payCompanyOrder(companyId, orderId, {
          comprobanteType,
          paymentMethod
        }));
      },
      [companyId, orderId]
    ),
    onError
  );
  return {
    loading,
    onPay
  };
}

export default usePayCompanyOrderCallback;
